import type { ReactNode } from 'react';
import { IconWarningTriangle } from '@/icons';
import { cn } from '@/helpers/classnames';

interface WarningBannerProps {
  children: ReactNode;
  className?: string;
  id?: string;
  /** Omit for default warning icon. Pass `null` to hide the icon. */
  icon?: ReactNode;
  /**
   * Announce the banner as soon as it appears. Leave false for guidance that
   * is already part of the screen, such as a form that opens with the warning.
   */
  announce?: boolean;
}

export const WarningBanner = ({
  children,
  className,
  icon,
  id,
  announce = true,
}: WarningBannerProps) => {
  return (
    <div
      id={id}
      role={announce ? 'alert' : undefined}
      className={cn(
        'flex flex-row items-center rounded-md bg-yellow-500 p-4 text-contrast-yellow [&_svg]:text-contrast-yellow',
        className,
      )}
    >
      {icon !== null && (
        <span className="mr-4 flex size-7 min-w-7 shrink-0 items-center justify-center [&_svg]:size-7 [&_svg]:min-w-7">
          {icon ?? (
            <IconWarningTriangle
              className="size-7 min-w-7"
              aria-hidden="true"
            />
          )}
        </span>
      )}
      <span>{children}</span>
    </div>
  );
};
